import script from "./fw05_Articles.vue?vue&type=script&setup=true&lang=js"
export * from "./fw05_Articles.vue?vue&type=script&setup=true&lang=js"

import "./fw05_Articles.vue?vue&type=style&index=0&id=5e7cdd0b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e7cdd0b"]])

export default __exports__